function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#arrow-left-wide_svg__clip0)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#1E388B"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.066 17.73a.916.916 0 000-1.297l-4.853-4.851 4.853-4.85a.918.918 0 00-1.298-1.299l-5.5 5.5a.917.917 0 000 1.298l5.5 5.5a.916.916 0 001.298 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.917 11.582a.917.917 0 00.917.916h19.25a.917.917 0 100-1.833H1.833a.917.917 0 00-.917.917z"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "arrow-left-wide_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "rotate(-180 11 11)",
  d: "M0 0h22v22H0z"
})));
function SvgArrowLeftWide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgArrowLeftWide;